/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Length } from './Length';
import {
    instanceOfLength,
    LengthFromJSON,
    LengthFromJSONTyped,
    LengthToJSON,
} from './Length';

/**
 * @type SourceAxisDistanceMin
 * 
 * @export
 */
export type SourceAxisDistanceMin = Length;


export function SourceAxisDistanceMinFromJSON(json: any): SourceAxisDistanceMin {
    return SourceAxisDistanceMinFromJSONTyped(json, false);
}

export function SourceAxisDistanceMinFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourceAxisDistanceMin {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...LengthFromJSONTyped(json, true) };
    return  LengthFromJSONTyped(json, true);
}

export function SourceAxisDistanceMinToJSON(value?: SourceAxisDistanceMin | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfLength(value)) {
        return LengthToJSON(value as Length);
    }

    return {};
}

/**
 * Check if a given object implements the SourceAxisDistanceMin interface.
 */
export function instanceOfSourceAxisDistanceMin(value: any): value is SourceAxisDistanceMin {
    if (instanceOfLength(value)) return true;
    return false;
}

